import React, {useEffect, useState} from "react"
import {BrowserRouter} from "react-router-dom"
import {getServices, IServices, ServiceContext} from "../../services/services"
import {getSettings} from "../../services/settings"
import {CategoryHelper, CategoryHelperContext} from "../../services/helpers/category-helper"
import {LoggedInUser, UnauthenticatedUser, UserContext} from "../../services/authentication/user-context"

export const AppContainer: React.FC = ({children}) => {
  const [services, setServices] = useState<IServices | null>(null)
  const [user, setUser] = useState<LoggedInUser>(UnauthenticatedUser)
  const [categoryHelper, setCategoryHelper] = useState<CategoryHelper | null>(null)

  useEffect(() => {
    getSettings()
      .then(async settings => {
        const services = getServices(settings, async user => {
          setUser(user)
          setServices(services)

          if (user !== UnauthenticatedUser) {
            const categories = await services.categoryApi.getAllCategories()
            const categoryHelper = new CategoryHelper(categories)
            setCategoryHelper(categoryHelper)
          }
        })
        await services.authenticationService.loadUser()
      })
  }, [])

  return <ServiceContext.Provider value={services}>
    <UserContext.Provider value={user}>
      <CategoryHelperContext.Provider value={categoryHelper}>
        <BrowserRouter>
          {children}
        </BrowserRouter>
      </CategoryHelperContext.Provider>
    </UserContext.Provider>
  </ServiceContext.Provider>
}